import { gql } from "@apollo/client";

const REMOVE_ACCOUNT = gql`
  mutation removeAccount($id: ID!, $email: String) {
    removeAccount(id: $id, Email: $email)
  }
`;

export default REMOVE_ACCOUNT;
